// extracted by mini-css-extract-plugin
export default {"tabsWrapper":"MaskOverlayHeader_tabsWrapper__7jsTG","linearProgress":"MaskOverlayHeader_linearProgress__1soC1"};